export default function filterBookings(bookings, appliedFilters) {
  const defaultFilter = () => true;

  const filterFunctions = Object.entries(appliedFilters).map(([k, v]) => {
    if (Array.isArray(v) && v.length === 0) {
      return defaultFilter;
    }

    switch (k) {
      case "includeInternal":
        if (!v) {
          return b => b.direction !== "internal";
        }
        return defaultFilter;
      case "direction":
        return b => {
          const values = v.map(({ value }) => value);
          return values.includes(b.direction);
        };
      case "status":
        return b => {
          const values = v.map(({ value }) => value);
          const bookingStatus = b.haulier === null ? "proposed" : b.status;
          return values.includes(bookingStatus);
        };
      case "haulier":
        return b => {
          if (!b.haulier) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.haulier.id);
        };
      case "sendingSite":
        return b => {
          const values = v.map(({ value }) => value);
          if (b.sendingSite) return values.includes(b.sendingSite.id);
          if (
            b.appointment &&
            b.appointment.data &&
            b.appointment.data.sending_site_description
          )
            return values.includes(b.appointment.data.sending_site_description);
          if (b.origin) return values.includes(b.origin);
          return false;
        };
      case "receivingSite":
        return b => {
          const values = v.map(({ value }) => value);
          if (b.receivingSite) return values.includes(b.receivingSite.id);
          if (
            b.appointment &&
            b.appointment.data &&
            b.appointment.data.receiving_site_description
          )
            return values.includes(
              b.appointment.data.receiving_site_description
            );
          if (b.origin) return values.includes(b.origin);
          return false;
        };
      case "loadType":
        return b => {
          if (!b.loadType) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.loadType);
        };
      case "trailerType":
        return b => {
          if (!b.trailerType) return false;
          const values = v.map(({ value }) => value);
          return values.includes(b.trailerType.id);
        };
      case "tag":
        return b => {
          const tag =
            b.appointment &&
            b.appointment.data &&
            b.appointment.data["journey_tag"];
          if (!tag) return false;
          const values = v.map(({ value }) => value);
          return values.includes(tag);
        };
      default:
        return defaultFilter;
    }
  });

  return bookings.filter(b => filterFunctions.every(af => af(b)));
}
